<template>
    <div class="container">
        <img src="@/assets/images/bg.jpg" v-if="$route.path=='/home'" alt="">
        <img src="@/assets/images/bg1.jpg" v-else alt="">
        <img class="logo" src="@/assets/images/logo.png" alt="">
        <div class="sloter">
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
    created(){
        console.log(this.$route)
    }
}
</script>
<style lang="scss"scope>
.container{
    width: 100%;
    height: 100%;
    position: relative;
    .logo{
        height: auto;
        position: absolute;
        left: 0;
        top: 72px;
    }
    .sloter{
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
    }
}
</style>